import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
// import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
// import CardMedia from '@material-ui/core/CardMedia';
// import Chip from '@material-ui/core/Chip';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
// import Collapse from '@material-ui/core/Collapse';
// import Avatar from '@material-ui/core/Avatar';
// import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
// import { red } from '@material-ui/core/colors';
// import FavoriteIcon from '@material-ui/icons/Favorite';
// import EditIcon from '@material-ui/icons/Edit';
// import DeleteIcon from '@material-ui/icons/Delete';
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import MoreVertIcon from '@material-ui/icons/MoreVert';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
    root: {
        boxShadow: '5px 5px 20px rgba(39, 53, 164, 0.21)',
        color: '#ffffff'
    },
    iconButton: {
        position: 'absolute', 
        right: 0, 
        bottom: -8,
        background: 'rgba(255, 255, 255, 0.2)'
    }
  }));

function CountBox(props) {
    const classes = useStyles();

    const { color, title, count, icon } = props;

    return (
        <Card className={classes.root} style={{backgroundColor: color}}>
            <CardContent style={{padding: '4px 16px'}}>
                <Typography  variant="h6" gutterBottom>
                {title}
                </Typography>
                <Typography variant="h4" component="h2" gutterBottom style={{position: 'relative', fontWeight: 'bold'}}>
                {count} 
                <IconButton className={classes.iconButton}>
                    {icon}
                </IconButton>
                </Typography>
            </CardContent>
        </Card>
    )
}

export default CountBox
